{
  "title": "Membagikan lokasi Anda dapat mempercepat proses check-in",
  "body": "Mohon maaf, kami tidak dapat menyelesaikan check-in Anda tanpa akses ke lokasi Anda. Harap berikan akses lokasi untuk melanjutkan. Kami hanya menggunakan lokasi Anda untuk keperluan check-in gudang dan tidak menyimpan atau membagikan informasi lokasi Anda kepada pihak ketiga.",
  "shareLocation": "Bagikan lokasi saya"
}
